import { Field, Formik, Form, ErrorMessage } from 'formik';
import React from 'react';
import { createActionSettingsSchema, validateItemIdBSLKey } from '../collection/Util';
import { getFieldDescriptionInfoByName } from '../../ActionFormUtils';
import { iconForField } from '../../../../common/custom/icon-library';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import CustomLoader from '../../../common/CustomLoader';
import { FieldTypes } from 'drapcode-constant';
import BrowserStorageLocationField from '../BrowserStorageLocationField';
import {
  SEND_ITEM_ID_FROM_OPTIONS_DESC,
  sendItemIdFromOptions,
} from '../../../../common/utils/event_constants';

export const PageRedirect = ({
  projectId,
  selectedEvent,
  eventAction,
  actionData,
  events,
  actions,
  hideModal,
  showLoaderForAction,
  version,
}) => {
  const RESET_ITEM_ID_FROM_VALUES = [
    'sendCurrentObjectID',
    'sendPreviousStepParentCollectionId',
    'sendCurrentPageItemId',
    'sendCurrentUserId',
    'sendTargetItemID',
    'sendCurrentPageReferenceItemId',
  ];

  const SEND_ITEM_ID_FIELDS = [
    'sendTargetItemID',
    'sendCurrentObjectID',
    'sendPreviousStepParentCollectionId',
    'sendCurrentUserId',
    'sendCurrentPageItemId',
    'sendCurrentPageReferenceItemId',
  ];

  const pageOptions = () => {
    return events.pages
      ? events.pages.map((item, key) => ({
          value: '/' + item.slug,
          label: item.name,
        }))
      : [];
  };

  const collectionOptions = () => {
    let options = [{ value: '', label: 'Choose Collection' }];
    let collections = events ? events.collections : [];
    if (collections.length > 0) {
      options = options.concat(
        collections.map((collection) => {
          return { value: collection.collectionName, label: collection.collectionTitle };
        }),
      );
    }
    return options;
  };

  const collectionReferenceFieldsOptions = (values) => {
    let options = [{ value: '', label: 'Choose Field' }];
    let collections = events ? events.collections : [];
    let collectionName = values['collection'] ? values['collection'] : '';
    if (collections.length > 0) {
      const collection = collections.find((coll) => coll.collectionName === collectionName);
      if (collection && collection.fields) {
        const collectionFields = collection.fields
          ? collection.fields.filter((e) =>
              [FieldTypes.reference.id, FieldTypes.createdBy.id, FieldTypes.belongsTo.id].includes(
                e.type,
              ),
            )
          : [];
        options = options.concat(
          collectionFields.map((field) => {
            if (field.fieldName) {
              const value =
                field.refCollection && field.refCollection.collectionName
                  ? `${field.fieldName}:${field.refCollection.collectionName}`
                  : '';
              return {
                value,
                label: field.fieldTitle.en,
              };
            }
          }),
        );
      }
    }
    return options;
  };

  const handleSubmit = (values) => {
    const { args } = actionData;
    let parameters = [];
    console.log('2 handleSubmit');
    const hasSendItemIdFrom = !!values['sendItemIdFrom']; // Fallback handling of Checkbox field values in the Dropdown

    Object.keys(values).map((value) => {
      const action = args.find((param) => param.name === value);
      console.log('action handleSubmit:>> ', action);
      parameters.push({
        name: value,
        value: hasSendItemIdFrom && RESET_ITEM_ID_FROM_VALUES.includes(value) ? '' : values[value],
        type: action.type,
      });
    });
    let actionFormData = eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    hideModal();
  };

  const onClickHandle = (args, values) => {
    const { name } = args;

    if (SEND_ITEM_ID_FIELDS.includes(name)) {
      // Reset all flags to false
      SEND_ITEM_ID_FIELDS.forEach((flag) => {
        values[flag] = false;
      });

      // Set the clicked flag to true
      values[name] = true;
    }
  };

  const renderCheckBox = (action, values) => {
    const radioArgs = action.args.filter(
      (args) => args.type === 'boolean' && args.name === 'isNewTab',
    );
    return radioArgs.map((args) => (
      <div className="form-group" key={args.name}>
        <div className="col-12">
          <div className="input-group">
            <div className="input-group-prepend" title={args.label}>
              <span className="input-group-text">
                <i className={`wb ${iconForField(args.type + '-toggle')}`}></i>
              </span>
            </div>
            <div className="form-check">
              <label className="form-check-label">
                <Field
                  type="checkbox"
                  name={args.name}
                  className="form-check-input"
                  title={args.name}
                  onClick={() => onClickHandle(args, values)}
                />
                {args.label}
                <span className="form-check-sign">
                  <span className="check"></span>
                </span>
              </label>
            </div>
            {getFieldDescriptionInfoByName(args, actionData)}
          </div>
        </div>
      </div>
    ));
  };

  const renderSendItemIdFrom = (action, setFieldValue, setFieldTouched, values) => {
    // Fallback handling of Checkbox field values in the Dropdown
    if (!values['sendItemIdFrom']) {
      if (values['sendCurrentObjectID']) {
        values['sendItemIdFrom'] = 'sendCurrentObjectID';
        values['sendCurrentObjectID'] = '';
      } else if (values['sendCurrentPageItemId']) {
        values['sendItemIdFrom'] = 'sendCurrentPageItemId';
        values['sendCurrentPageItemId'] = '';
      } else if (values['sendCurrentPageReferenceItemId']) {
        values['sendItemIdFrom'] = 'sendCurrentPageReferenceItemId';
        values['sendCurrentPageReferenceItemId'] = '';
      } else if (values['sendCurrentUserId']) {
        values['sendItemIdFrom'] = 'sendCurrentUserId';
        values['sendCurrentUserId'] = '';
      } else if (values['sendPreviousStepParentCollectionId']) {
        values['sendItemIdFrom'] = 'sendPreviousStepParentCollectionId';
        values['sendPreviousStepParentCollectionId'] = '';
      } else if (values['sendTargetItemID']) {
        values['sendItemIdFrom'] = 'sendTargetItemID';
        values['sendTargetItemID'] = '';
      }
    }

    return (
      <div className="form-group">
        <FormFieldWithLabel
          cta={false}
          label="Send Item ID From"
          icon="select"
          infoIcon={true}
          infoDescription={SEND_ITEM_ID_FROM_OPTIONS_DESC}
        >
          <CustomSelect
            name={'sendItemIdFrom'}
            isMulti={false}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            options={sendItemIdFromOptions()}
            value={values['sendItemIdFrom']}
          />
          <ErrorMessage name={'sendItemIdFrom'}>
            {(msg) => <p className="text-error">{msg}</p>}
          </ErrorMessage>
        </FormFieldWithLabel>
      </div>
    );
  };

  // Fallback handling of Checkbox field values in the Dropdown
  const isSendCurrentPageReferenceItemIdEnabled = (values) => {
    let isEnabled = false;
    if (!values['sendItemIdFrom']) {
      isEnabled = !!values['sendCurrentPageReferenceItemId'];
    } else {
      isEnabled = values['sendItemIdFrom'] === 'sendCurrentPageReferenceItemId';
    }
    return isEnabled;
  };

  const isSendBSLItemIdEnabled = (values) => {
    return values['sendItemIdFrom'] === 'sendBSLItemId';
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={createActionSettingsSchema(actionData, eventAction)}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue, setFieldTouched }) => (
        <Form>
          <div className="form-group">
            <FormFieldWithLabel
              cta={false}
              label="Destination"
              icon="select"
              infoIcon={true}
              infoDescription={'Select Page which you want to Land on.'}
            >
              <CustomSelect
                name={'destination'}
                isMulti={false}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                options={pageOptions()}
                value={values['destination']}
              />
              <ErrorMessage name={'destination'}>
                {(msg) => <p className="text-error">{msg}</p>}
              </ErrorMessage>
            </FormFieldWithLabel>
          </div>
          {renderCheckBox(actionData, values)}
          {renderSendItemIdFrom(actionData, setFieldValue, setFieldTouched, values)}
          {isSendCurrentPageReferenceItemIdEnabled(values) && (
            <>
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Current Page Collection"
                  icon="select"
                  infoIcon={true}
                  infoDescription={'Select Collection'}
                >
                  <CustomSelect
                    name={'collection'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={collectionOptions()}
                    value={values['collection']}
                  />
                  <ErrorMessage name={'collection'}>
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </FormFieldWithLabel>
              </div>
              {values['collection'] && (
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Reference Field"
                    icon="select"
                    infoIcon={true}
                    infoDescription={'Select Reference Field'}
                  >
                    <CustomSelect
                      name={'referenceField'}
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={collectionReferenceFieldsOptions(values)}
                      value={values['referenceField']}
                    />
                    <ErrorMessage name={'referenceField'}>
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>
              )}
            </>
          )}
          {isSendBSLItemIdEnabled(values) && (
            <>
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Item Collection"
                  icon="select"
                  infoIcon={true}
                  infoDescription={'Item Collection'}
                >
                  <CustomSelect
                    name={'bslCollection'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={collectionOptions()}
                    value={values['bslCollection']}
                  />
                  <ErrorMessage name={'bslCollection'}>
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </FormFieldWithLabel>
              </div>
              {values['bslCollection'] && (
                <>
                  <BrowserStorageLocationField
                    fieldName={'browserStorageLocation'}
                    values={values}
                    description={
                      'Select a browser storage location to get an Item ID key (Default: Session Storage).'
                    }
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                  />
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Item ID JSON Key"
                      icon="text"
                      infoIcon={true}
                      infoDescription={`Enter the key which contains Item ID value in your web browser storage.`}
                    >
                      <Field
                        type="text"
                        name="itemIdBSLKey"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        placeholder="Item ID JSON Key Eg. Key1 or, Parent_Key1.Child_Key[0]"
                        validate={validateItemIdBSLKey}
                      />
                    </FormFieldWithLabel>
                    <ErrorMessage name={'itemIdBSLKey'}>
                      {(msg) => <p className="text-error ml-5">{msg}</p>}
                    </ErrorMessage>
                  </div>
                </>
              )}
            </>
          )}
          <div className="row">
            <div className="col-md-6 text-left">
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={hideModal}
              >
                <span>
                  <i className="wb webconnect-times"></i>&nbsp;Cancel
                </span>
              </button>
            </div>
            <div className="col-md-6 text-right">
              <button type="submit" className="btn btn-theme-submit btn-sm">
                <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                <CustomLoader loading={showLoaderForAction} />
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
